export default (theme: any) => ({
    gridItemContent: {
        marginTop: '5px',
        width: '100%',
        '& .MuiInputBase-input': {
            height: 'unset',
        },
    },

    popper: {
        overflow: 'visible',
    },

    paper: {
        marginTop: '.1rem',
        background: '#ffffff',
        borderRadius: '12px',
        border: `1px solid ${theme.palette.lightGrey.medium}`,
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        minHeight: '3rem',
    },
})
